import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon/Icon';

import parentStyles from '../../OrderPayment.module.scss';

import styles from './PaymentError.module.scss';

interface PaymentErrorProps {
  description: string;
  onAction: () => void;
  isActionLoading: boolean;
}

export const PaymentError = ({
  description,
  onAction,
  isActionLoading,
}: PaymentErrorProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.errorBody}>
        <Icon type="wallet" size={200} className={styles.walletIcon} />
        <h1>{t('paymentNotConfirmed')}</h1>
        <p>{description}</p>
      </div>
      <div className={parentStyles.orderPaymentPageContentButtons}>
        <p className={styles.returnHint}>{t('paymentReturnToCheckoutHint')}</p>
        <button
          type="button"
          className="button _primary product-card__buy _m"
          onClick={onAction}
          disabled={isActionLoading}
        >
          {t('okButton')}
        </button>
      </div>
    </>
  );
};
